'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const MktgChart = dynamic(() => import('@/app/sales-engine/components/MarketingAttributionChart'), { ssr: false });

const sources = [
  { id: 'ma-google', source: 'Google Ads', leads: 48, revenue: '$32,400', cpl: '$84', roi: '4.8x', pct: 38, color: 'bg-secondary' },
  { id: 'ma-seo',    source: 'SEO / Organic', leads: 31, revenue: '$22,100', cpl: '$0', roi: '∞', pct: 26, color: 'bg-success' },
  { id: 'ma-ref',    source: 'Referral', leads: 28, revenue: '$19,800', cpl: '$0', roi: '∞', pct: 20, color: 'bg-accent' },
  { id: 'ma-fb',     source: 'Facebook Ads', leads: 22, revenue: '$8,200', cpl: '$112', roi: '1.9x', pct: 11, color: 'bg-warning' },
  { id: 'ma-yelp',   source: 'Yelp Ads', leads: 13, revenue: '$3,500', cpl: '$94', roi: '1.4x', pct: 5, color: 'bg-danger' },
];

export default function MarketingAttributionPanel() {
  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-foreground">Marketing Attribution</h3>
          <p className="text-xs text-muted-foreground mt-0.5">142 leads · $86,000 revenue generated today</p>
        </div>
        <div className="text-right">
          <div className="text-xs text-muted-foreground">Best performing</div>
          <div className="text-xs font-semibold text-success">SEO + Referral (∞ ROI)</div>
        </div>
      </div>
      <div className="px-5 py-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        <MktgChart />
        <div className="space-y-3">
          {sources?.map((s) => (
            <div key={s?.id}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-foreground">{s?.source}</span>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-muted-foreground">{s?.leads} leads</span>
                  <span className="text-xs font-semibold text-success font-tabular">{s?.revenue}</span>
                  <span className={`text-xs font-bold font-tabular ${s?.roi?.includes('∞') ? 'text-success' : parseFloat(s?.roi) >= 3 ? 'text-success' : parseFloat(s?.roi) >= 2 ? 'text-warning' : 'text-danger'}`}>{s?.roi}</span>
                </div>
              </div>
              <div className="w-full bg-muted rounded-full h-1.5 overflow-hidden">
                <div className={`h-1.5 rounded-full transition-all duration-700 ${s?.color}`} style={{ width: `${s?.pct}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}